export const URL = 'https://www.youtube.com/embed/N56YpTq8Oes?&origin=http://readybid.net'
export const URL_AUTOPLAY = 'https://www.youtube.com/embed/N56YpTq8Oes?autoplay=1&origin=http://readybid.net'